import STATES from '../../core/us-states';

/**
 * @public
 * Gets the array of states in the U.S.
 *
 * @returns {Array}
 */
export default function getAllStates() {
  return STATES;
}
